import { Color } from '@/components/portfolio/components/sharedTypes'
import { clientHomeData, clientPageData, PortfolioComponent } from '../../type/client-index'
import { After, Before, BettyJeaneProfile, Cover } from './assets'

export const home: clientHomeData = {
  slug: 'betty-jeane',
  name: 'Betty Jeane',
  types: ['Audit Instagram'],
  image: Cover
}

const detailed: clientPageData = {
  seo: {
    title: 'Betty Jeane',
    description: 'Découvrez notre travail avec Betty Jeane.'
  },
  blocks: [
    {
      id: 1,
      componentName: PortfolioComponent.presentationSlide,
      props: {
        title: home.name,
        types: home.types,
        titleColor: Color.yellow,
        images: [BettyJeaneProfile],
        urls: {
          website: 'https://bettyjeane.com',
          instagram: 'https://www.instagram.com/bettyjeane/'
        },
        subtitle: 'La marque',
        descriptionRight: true,
        variant: 2,
        description: {
          cols: 2,
          content: [
            'Professeure de couture, Caroline aussi connue sous le nom de Betty Jeane, partage de nombreux conseils à sa communauté via ses réseaux sociaux.',
            "Que ce soit sous forme de lives Instagram ou encore de posts explicatifs, c'est toujours avec un grand sourire qu'elle vous guidera vers les bonnes pratiques de la couture !"
          ]
        }
      }
    },
    {
      id: 2,
      componentName: PortfolioComponent.imageGrid,
      props: {
        cols: 1,
        images: [Before, After],
        ratio: Before.height / Before.width,
        variant: 3
      }
    },
    {
      id: 3,
      componentName: PortfolioComponent.imageGrid,
      props: {
        title: 'Notre travail',
        description: {
          cols: 2,
          content: [
            "Désireuse de faire évoluer son compte Instagram, Betty Jeane a contacté Atelier Milky pour la réalisation d'un audit. Véritable état des lieux, il lui a permis de comprendre les bonnes comme les mauvaises pratiques qu'elle avait mises en place.",
            "Diagnostic complet, l'audit comprend non seulement une analyse objective du compte mais propose également une étude plus poussée des statistiques et pratiques de la marque. Toujours dans un but d'évolution, de nombreuses pistes d'améliorations sont suggérées au fil des pages !"
          ]
        },
        rightPadding: true,
        images: []
      }
    }
  ]
}

export default detailed
